!(function (e, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
      ? define(t)
      : ((e =
          "undefined" != typeof globalThis
            ? globalThis
            : e || self).EmblaCarouselAutoScroll = t());
})(this, function () {
  "use strict";
  const e = {
    direction: "forward",
    speed: 2,
    startDelay: 1e3,
    active: !0,
    breakpoints: {},
    defaultInteraction: !0,
    rootNode: null,
  };
  function t(n = {}) {
    let o,
      i,
      r,
      s,
      u = !1,
      a = !1,
      c = 0,
      l = 0,
      d = !1,
      f = !1,
      p = !1,
      g = w;
    function m() {
      return !u && !a && o.active;
    }
    function y() {
      if (!m()) return;
      const e = i.internalEngine(),
        { ownerWindow: t } = e.nodeHandler;
      if (!t) return;
      if (d) return;
      (i.createEvent("autoscroll:play", null).emit(),
        (l = t.setTimeout(() => {
          ((e.scrollBody = (function (e) {
            const {
                location: t,
                previousLocation: n,
                offsetLocation: r,
                target: s,
                scrollTarget: u,
                indexCurrent: a,
                indexPrevious: l,
                limit: { pastMinBound: d, pastMaxBound: f, clamp: p },
                options: { loop: g },
              } = e,
              m = "forward" === o.direction ? -1 : 1,
              y = () => D;
            let w = 0,
              E = 0,
              b = t.get(),
              B = 0,
              S = !1;
            function x() {
              let e = 0;
              (n.set(t),
                (w = m * c),
                (b += w),
                t.add(w),
                s.set(t),
                (e = b - B),
                (E = Math.sign(e)),
                (B = b));
              const y = a.get(),
                x = u.byDistance(0, !1).index;
              if (y !== x) {
                (l.set(y), a.set(x));
                i.createEvent("select", {
                  sourceSnap: y,
                  targetSnap: x,
                }).emit();
              }
              const h = "forward" === o.direction ? d(r) : f(r);
              if (!g && h) {
                S = !0;
                const e = p(t);
                (t.set(e), s.set(t), v());
              }
              return D;
            }
            const D = {
              direction: () => E,
              duration: () => -1,
              velocity: () => w,
              settled: () => S,
              seek: x,
              useBaseFriction: y,
              useBaseDuration: y,
              useFriction: y,
              useDuration: y,
            };
            return D;
          })(e)),
            e.animation.start());
        }, r)),
        (d = !0));
    }
    function v() {
      if (!m()) return;
      const e = i.internalEngine(),
        { ownerWindow: t } = e.nodeHandler;
      if (!t) return;
      if (!d) return;
      (i.createEvent("autoscroll:stop", null).emit(),
        (e.scrollBody = s),
        t.clearTimeout(l),
        (l = 0),
        (d = !1));
    }
    function w(e, t, n) {
      const o = t.type,
        i = n || o;
      ("slidefocus" === i && v(), "pointerdown" === i && v());
    }
    function E(e, t, n) {
      const o = t.type,
        r = n || o;
      ("mouseenter" === r && (f = !0),
        "mouseleave" === r && (f = !1),
        "pointerdown" === r && (p = !0),
        "pointerup" === r && (p = !1));
      i.createEvent("autoscroll:interaction", {
        interaction: r,
        originalEvent: t,
        isMouseOver: f,
        isPointerDown: p,
      }).emit();
    }
    function b() {
      (i.off("settle", b), y());
    }
    return {
      name: "autoScroll",
      options: n,
      init: function (l, d) {
        i = l;
        const { mergeOptions: f, optionsAtMedia: p } = d,
          y = f(e, t.globalOptions),
          v = f(y, n);
        if (((a = !1), (o = p(v)), (u = i.internalEngine().isSsr), !m()))
          return;
        if (i.snapList().length <= 1) return;
        ((c = o.speed),
          (r = o.startDelay),
          (a = !1),
          (s = i.internalEngine().scrollBody),
          (g = o.defaultInteraction ? w : E));
        const { eventStore: b } = i.internalEngine(),
          B = (function (e, t) {
            const n = e.rootNode();
            return (t && t(n)) || n;
          })(i, o.rootNode);
        (i.on("pointerdown", g),
          i.on("pointerup", g),
          i.on("slidefocus", g),
          b.add(B, "mouseenter", (e) => g(i, e, e.type)),
          b.add(B, "mouseleave", (e) => g(i, e, e.type)),
          b.add(i.containerNode(), "focusout", (e) =>
            g(i, e, "slidefocusout"),
          ));
      },
      destroy: function () {
        m() &&
          (i
            .off("pointerdown", g)
            .off("pointerup", g)
            .off("slidefocus", g)
            .off("settle", b),
          v(),
          (a = !0),
          (d = !1));
      },
      play: function (e) {
        (void 0 !== e && (r = e), y());
      },
      stop: function () {
        d && v();
      },
      reset: function () {
        d && (v(), i.on("settle", b));
      },
      isPlaying: function () {
        return d;
      },
      setSpeed: function (e) {
        c = e(o.speed);
      },
    };
  }
  return ((t.globalOptions = void 0), t);
});
